import React, { useCallback } from 'react';
import { Modal, Typography, Button, message } from 'antd';
import { DownloadOutlined } from '@ant-design/icons';

const { Paragraph } = Typography;

interface Props {
  open: boolean;
  onClose: () => void;
}

const ExcelGuideModal: React.FC<Props> = ({ open, onClose }) => {
  const handleDownloadGuide = useCallback(async () => {
    try {
      const link = document.createElement('a');
      // public/slot_guide.xlsx 를 그대로 다운로드 (서버 호출 없이 로컬 정적 파일 사용)
      link.href = `${process.env.PUBLIC_URL || ''}/slot_guide.xlsx`;
      link.setAttribute('download', 'slot_guide.xlsx');
      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch (error) {
      message.error('엑셀 가이드 다운로드에 실패했습니다.');
    }
  }, []);

  return (
    <Modal
      title="엑셀 업로드 가이드"
      open={open}
      onCancel={onClose}
      footer={[
        <Button key="close" onClick={onClose}>
          닫기
        </Button>,
        <Button
          key="download"
          type="primary"
          icon={<DownloadOutlined />}
          onClick={handleDownloadGuide}
        >
          가이드 다운로드
        </Button>,
      ]}
    >
      <Typography>
        <Paragraph>
          먼저 <strong>엑셀 가이드</strong>를 다운로드하고, 양식에 맞춰 데이터를 입력하세요.
        </Paragraph>
        <Paragraph>
          업로드한 엑셀의 내용은 <strong>기존 데이터에 추가됩니다.</strong>
        </Paragraph>
      </Typography>
    </Modal>
  );
};

export default ExcelGuideModal;
